<template>

	<div style="width: 80%; border: 1px solid red; margin: 0 auto;border-style:solid solid none solid; border-left-style:1px solid red;background: #fff;border-right-style:1px solid red;padding-bottom: 24px;
	margin-top: 24px">
		    <div style="font-size: 66px;color:#000;">服务协议 和 隐私政策</div>
		    
		    <div style="text-align:left; padding: 24px;">
		    	<span>
		    		<div  style="font-size: 27px;text-align:left;">一·服务协议</div>
		    				    	 1.服务的使用 <br><br>

权利授予。为了订阅服务，我们依据本协议条款及条件授予您非独家、不可转让、不可再许可和有限的许可。您应当遵守本协议以及与您访问使用的服务相关的法律法规。您可以允许您的最终用户访问和使用本服务，但您应让最终用户受本协议的条款和条件约束，并对其违约负责。如果您意识到最终用户对本协议的任何违反，您将立即通知我们，并采取适当的行动来纠正此类违规行为，包括但不限于暂停或终止该最终用户访问或使用服务。<br><br>

您的账户。注册账户时，您需要提供真实、准确的信息。如果您的信息发生变更，请及时在您的账户中对信息进行更新。您对您的账户的保密性，以及用于启用您访问服务的任何密码、身份验证密钥或安全凭据的安全性负责;和所有在您账户下的活动，不论是您还是您的最终用户的活动负责。如果您的账户下有任何未经授权或滥用行为或者任何与服务相关的安全事件，您将立即通知我们。您认可并同意我们不会对您账户中任何未经授权或滥用行为负责，除非这是由我们违反本合同所造成的。
<br><br>
实名认证就某些云服务的开通 拍界可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。仅在完成相应身份认证及资格验证后，您才可以订购及使用相关云服务。您理解并同意拍界有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效。
可接受的使用政策。除本协议的条款和条件外，您同意遵守可接受的使用政策。该政策通过援引成为本协议的一部分，您可以在如下网址查看此可接受使用政策的当前版本<br>

您的内容。您应确保您的内容不违反本协议的条款和条件并且符合法律法规。您应对您的内容的合法性、准确性、完整性和可靠性负责。作为服务条款的一部分，您应负责获得并持续保有任何与您的内容相关的通知、同意或授权。除非法律另有明确规定，否则我们不承担任何与您的内容有关的义务和责任。
第三方内容。服务中可能包含或向您提供第三方内容。第三方内容可能受到本协议或者服务条款与文件中制定的单独条款和条件的约束（如适用）。第三方内容基于“现状”和“当前可用”而提供。我们不对任何第三方内容作出任何形式的陈述或保证，也不对任何第三方内容造成的任何性质或种类的损失、损害、费用或成本承担任何责任。
<br><br>
预览版。预览版是指我们免费提供的供您试用的服务或服务功能。服务按“现状”和“当前可用”的形式提供，本协议中规定的保证条款不适用该类服务。对预览版我们可能不会提供用户支持，我们也可能会在不另行通知的情况下随时更改或者停止提供预览版。我们没有义务发布或发售预览版。您的网络和连接。除双方另有书面约定外，您应确保贵方网络和系统符合我们随时提供的相关规范；全权负责采购和维护从您的系统到我们或任何第三方数据中心的网络连接和电信连接；并且（c）自行承担所有因您的网络连接、电信连接或因互联网引起的或与之相关的所有问题、条件、延迟、交付失败和所有其他损失、损坏、责任、费用或任何性质或种类的费用也可付费享受内容更丰富、体验更佳的高级别支持，包括开发者级、商业级、企业级。支持计划的详细说明请参见链接<br><br>

2.安全和数据隐私<br><br>

        我们的安全性。在不违反第1.5条和2.3要规定之义务的前提下，我们将采取适当的管理、物理和技术措施帮助您保护在服务环境下存储的您的内容的安全性和保密性。我们不会访问或者使用您的内容，除非是为您提供必要的服务，或者为遵守法律法规或政府机关的约束性命令。数据隐私您可以指定您的内容所存储的区域。未经您的同意，我们不会从您选择的区域中迁移您的内容，除非必须迁移以遵守适用的法律法规或者政府机关的约束性命令;为了提供账单、管理、技术服务或者因调查安全事件或者调查违反本协议的行为。我们可能会在您使用服务的数据中心区域处理一些数据，我们也可能会在我们维护运营、支持和调查系统及团队的区域处理这些数据。您的安全。在不违反上述2.1节的情况下，您应对任何安全漏洞以及由您的内容引起或与之相关的此类漏洞的后果负责，包括但不限于您的内容中包含的任何病毒、特洛伊木马、蠕虫或其他有害的编程程序。
<br><br>
3.费用及支付<br><br>

        服务费。您将根据我们网站或适用的订单表中指定的定价、付款方式和规则向我们支付所订购和/或使用的服务的费用。我们可能提前7天通知调整价格、付款方式和规则。您可以通过查看更新后的价格、付款方式和规则。请您采用我们支持的付款方式和币种（您通过中国站购买的服务默认人民币，国际站购买的服务付款币种要求与发票一致）付款。付款人应与您在云官网注册或实名认证（中国站）的名称一致，如因付款主体与认证主体不一致导致金融合规风险，相关后果由您承担。我们按月度开具账单，并在出账单后向您开具发票。您认可并同意，如果我们合理地认为存在欺诈或您可能会违反您的付款义务，我们可能会调整您的付款频率或付款方式。
        税款。服务费用不包括代扣税、增值税（您通过中国站购买的服务价款已包含增值税）、销售税、商品和服务税（GST）或者任何在相关国家使用的相似或类似的税，如果有，应根据现行的相关法律法规收取。根据适用法律和法规的要求，协议各方均有责任确认并承担因本协议下的交易和支付而加于该方的所有税费和其他政府费用（以及任何罚款、利息和其他附加费）。如果根据您所在国家法规，您应在向方付款时缴纳任何税费（包括但不限于预提税/代扣税），那么您须自行支付该等必要的税费，单项中的金额。因您延迟或未缴纳税费而产生的补税款、罚金或利息，由您承担。<br><br>

4.声明与保证<br><br>

双方声明。双方均声明其合法有效地签署了本协议，具有相应的权利和授权。
 您的声明和保证。您声明、保证并承诺您应遵守与您在本协议项下的活动有关的所有适用法律和法规；您在使用服务时应遵守《可接受的使用政策》；您对服务的使用不得侵犯任何第三方的知识产权或任何其他权利。
我们的有限保证。我们保证在服务期间会使用商业上合理的努力和技术来满足SLA中的规定，并已在SLA中列出所有对您的补救措施。我们不就下述问题负责任何由您的内容或第三方内容或者任何不由我们提供的产品和/或服务所引起的问题，或任何因滥用或修改服务或违反本协议条款及法律法规使用服务而引起的任何问题。预览版服务和试用服务基于“现状”和“当前可用”而提供，不适用任何保证。免责声明。 我们不就下述行为进行保证：服务将无错误或不会中断；我们会修正与服务有关的所有缺陷或错误，或防止与本服务有关的所有第三方破坏或未经授权的访问；或本服务将与您的内容或本公司未提供的任何其他硬件、软件、系统、服务或数据兼容。在法律允许的范围内,除非另有明文规定, 否则我们排除并明确拒绝任何保证、陈述、条款、条件或其他任何形式的承诺, 无论是明示的或默示的, 法定的或其他方式，包括但不限于任何针对适销性、质量满意度、非侵权性或特定用途适用性的保证、陈述、条款、条件或其他承诺。<br><br>

5.所有权与限制<br><br>

您的内容。您和/或您的许可方保留您的内容中的知识产权。根据本协议，您授予我们托管、处理和/或传输您的内容以运行和提供服务的权利。
提供的服务。我们和/或我们的许可方保留本协议项下服务（包括任何基础软件程序及其所有部分、复制和修改）、服务衍生品以及由我们或代表我们开发或交付的任何内容的所有权、知识产权和权益。除本协议另有明确规定外，本协议中任何内容均不得解释为授予您在本服务中或与本服务相关的任何权利、所有权和利益。限制。您不得、也不能使得或允许最终用户或允许其他人修改、变更服务或制造服务的衍生品；对服务进行反汇编、反编译、反向工程、复制服务的任何部分，或应用其他任何程序来获得服务中所包含的任何软件的源代码；分发、转售、再许可、或转让服务，除非本协议另有规定或经双方书面同意；为了下述目的访问服务：建立具有竞争力的产品或服务；复制服务的任何特征、功能或图形；或执行或披露服务的任何基准测试、安全测试或性能测试。
反馈与建议。如果您或您的最终用户向我们或与服务有关的我们的关联方提出任何与开展服务有关的反馈、建议、请求或意见（“客户建议”），您认可并同意，我们和我们的关联方有权不受限制地使用客户建议，包括但不限于任何将使用客户建议和将客户建议纳入我们的服务以开发新功能或提高服务的性能、功能性或安全性的权利，我们也将保留其所有权、知识产权和权益。<br><br>

6.赔偿<br><br><br>

6.1 我们的赔偿。如果第三方向您提出索赔，指出我们提供并由您使用的服务侵犯了第三方的知识产权，我们将自费为您辩护，并就最终法院判决或与第三方的和解给您造成的损失、成本和费用进行赔偿，前提是您：及时以书面形式通知我们此类索赔；同意由我方主导抗辩与和解向我们提供进行抗辩或解决索赔所需的一切合理信息、权限和协助。我们可以自行决定在不实质影响服务功能的前提下，修改被指控侵权的该部分服务，使其不侵权；就被指控侵权的该部分服务取得合法授权；或终止提供服务，并在事先书面通知的情况下退还未使用服务的预付费用。我们不会就以下情形引起的索赔向您提供赔偿：由于您使用或将服务与其他任何一方的软件、硬件或我们未提供的内容结合使用的；由于您的内容、第三方内容或因为您违反本协议引起的；由于您更改服务或在服务文件中标识的使用范围之外使用服务（或您使用服务的方式与我们给您的指导相背）而引起的；（d）由于非我们操作的、对服务或者基础软件的任何修改引起的；为了遵守或执行行业标准或任何适用法律法规引起的；在因第三方索赔而被通知停止使用本服务后，您继续使用本服务而引起的；或可以通过变更或升级当前版本或采取我们建议的措施避免侵权，但您未能配合更新或升级至最新版本，或者未能执行我们的建议引起的。<br><br>

6.2 您的赔偿。如果第三方向我们提出索赔，指出您的内容或我们根据本协议使用的您的内容或您的内容与我们服务的结合侵犯了第三方的知识产权,或您以非法方式或违反本协议规定使用服务，您将自费为我们辩护，并就最终法院判决或与第三方的和解给我们造成的损失、成本和费用进行赔偿，前提是我们及时以书面形式通知你们此类索赔；同意由您主导抗辩与和解；向您提供进行抗辩或解决索赔所需的一切合理信息、权限和协助。我们可以自行决定暂停或终止提供服务、本协议或适用的订单表而不退还已缴付的任何费用。如果此类索赔是直接由我方违反本协议引起的，您不必对我方做出赔偿。<br><br>

6.3 排他性救济。本赔偿条款为双方就任何侵权索赔可以获得的唯一救济。<br><br>

7.保密

7.1 保密信息的定义。“保密信息”是指在与本协议有关的交易过程中，由一方（“披露方”）向另一方（“接收方”）或向接收方（或其关联方）的雇员、高级职员、客户或供应商披露的涉及披露方（或其关联方）的所有信息，不论此信息为本协议签署日期之前或之后披露，以任何媒体或形式（包括书面、口头、视觉或电子）存在，是否被标记或描述为“机密”, 或者和披露方（若其关联方）、其雇员、高级职员、客户或供应商相关的，基于其披露环境和信息性质，合理地应被理解为保密的信息。保密信息不应包括以下信息:非因另一方的作为或不作为而已为公众所知或将为公众所知的信息；在披露前为另一方合法占有且未违反对披露方的保密义务；第三方合法向另一方披露的信息，而第三方就该信息本身不负有保密义务；或由另一方独立开发的信息。<br><br>

7.2 保密信息的保护。各方均同意在本协议有效期内及之后的五年内对对方的保密信息保密。除非按照本第7条的规定或经对方事先书面同意，任何一方不得将另一方的保密信息披露给任何人。各方同意采取合适的措施保护另一方的保密信息，且保护程度不低于其保护自己的保密信息。<br><br>

7.3 允许披露。接收方只能将保密信息披露给必须知道这些信息且负有不低于本协议规定的保密义务的员工、代理人或分包商。除非另一方另有授权，双方仅可将对方的保密信息用于履行本协议之目的。但一方可以在法律诉讼中或根据法律要求披露另一方的保密信息。<br><br>


<div  style="font-size: 27px;text-align:left;">二·隐私政策</div><br><br>
    1. 适用范围

    a) 在您注册中国农技推广帐号时，您根据中国农技推广要求提供的个人注册信息（商家应法律法规要求需公示的企业名称及相关工商注册信息除外）；<br><br>

    b) 在您使用中国农技推广网络服务，或访问中国农技推广平台网页时，中国农技推广自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；<br><br>

    c) 中国农技推广通过合法途径从商业伙伴处取得的用户个人数据。<br><br>

    您了解并同意，以下信息不适用本隐私权政策：<br><br>

    a) 您在使用中国农技推广平台提供的搜索服务时输入的关键字信息；<br><br>

    b) 中国农技推广收集到的您在中国农技推广发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；<br><br>

    c) 违反法律规定或违反中国农技推广规则行为及中国农技推广已对您采取的措施。<br><br>

    2. 信息使用<br><br>

    a) 中国农技推广不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和中国农技推广（含中国农技推广关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。<br><br>

    b) 中国农技推广亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何中国农技推广平台用户如从事上述活动，一经发现，中国农技推广有权立即终止与该用户的服务协议。<br><br>

    c) 为服务用户的目的，中国农技推广可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与中国农技推广合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。<br><br>

    3. 信息披露<br><br>

    在如下情况下，中国农技推广将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：<br><br>

    a) 经您事先同意，向第三方披露；<br><br>

    b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；<br><br>

    c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；<br><br>

    d) 如您出现违反中国有关法律、法规或者中国农技推广服务协议或相关规则的情况，需要向第三方披露；<br><br>

    e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；<br><br>

    f) 在中国农技推广平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，中国农技推广有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。<br><br>

    g) 其它中国农技推广根据法律、法规或者网站政策认为合适的披露。<br><br>


    4. 信息存储和交换<br><br>

    中国农技推广收集的有关您的信息和资料将保存在中国农技推广及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或中国农技推广收集信息和资料所在地的境外并在境外被访问、存储和展示。<br><br>

    5. Cookie的使用<br><br>

    a) 在您未拒绝接受cookies的情况下，中国农技推广会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的中国农技推广平台服务或功能。中国农技推广使用cookies可为您提供更加周到的个性化服务，包括推广服务。<br><br>

    b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的中国农技推广网络服务或功能。<br><br>

    c) 通过中国农技推广所设cookies所取得的有关信息，将适用本政策。<br><br>

    6. 信息安全<br><br>
    
    a) 中国农技推广帐号均有安全保护功能，请妥善保管您的用户名及密码信息。中国农技推广将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。<br><br>

    b) 在使用中国农技推广网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是中国农技推广用户名及密码发生泄露，请您立即联络中国农技推广客服，以便中国农技推广采取相应措施。<br><br>
		    	</span>


		    </div>
       
	</div>
	
</template>
<script>
import qs from 'qs';
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
		return{

		}
	 },
	created(){
		// 显示公共栏
		// this.$emit('header', true)
		this.$emit('footer', true)


		// 页面至顶部
		window.scrollTo(0,0);
	},
	methods: {
	
	},
	mounted(){
		
	},
	computed: {

	}
}
</script>